// extracted by mini-css-extract-plugin
module.exports = {"tabs-wrapper":"TabbedView_tabs-wrapper__EkLK0","tab-list":"TabbedView_tab-list__1vIwB","tab":"TabbedView_tab__1Au6T","active":"TabbedView_active__1lrZa"};